// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationInTransitPath = 'M100 36.99a10.396 10.396 0 00-10.396-10.119H70.297V24.12A10.396 10.396 0 0059.901 14H11.109c-1.98.053-5.35.053-10.109 0v57.218a10.396 10.396 0 0010.386 10.109h.624a12.366 12.366 0 0024.138 0h33.466a12.366 12.366 0 0024.317-.911A10.387 10.387 0 00100 70.96V36.99zM24.099 85.07a6.436 6.436 0 116.436-6.436 6.446 6.446 0 01-6.436 6.435zm39.267-10.674H35.713a12.357 12.357 0 00-23.238 0h-1.287a3.475 3.475 0 01-3.277-3.465V24.208 20.94h52.178a3.455 3.455 0 013.267 3.455l.01 50zm18.198 10.673A6.436 6.436 0 1188 78.634a6.445 6.445 0 01-6.436 6.435zm.13-18.812a12.376 12.376 0 00-10.951 6.614s0-.099.069-.138a3.476 3.476 0 01-.515-1.802V37.079c.12-1.089.12-2.188 0-3.277h19.505a3.455 3.455 0 013.267 3.455v9.406H75.247v6.931H93.07V71.11a3.406 3.406 0 01-.505 1.604 12.396 12.396 0 00-10.87-6.456z';
var IllustrationInTransit = baseIllustration('IllustrationInTransit', {
  getPath: () => IllustrationInTransitPath
}, 'ColoredIllustrationInTransit');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationInTransit;
//# sourceMappingURL=index.js.map